import markets from '@prisjakt/web-app-config/markets';
import { aggregateRating } from './aggregate-rating';
import { aggregateOffer } from './aggregate-offer';
import { brand } from './brand';
import { offer } from './offer';
import { reviews } from './review';
import { corePropertyValue } from './core-property-value';
import { productSchema } from './product-schema';
import { graph } from './open-graph';
import { faqPage } from './faq';
import {
  getTitleTranslationKey,
  getDescriptionTranslationKey,
  getHrefLang,
  getCanonical,
  getMeta,
} from './utils';

export default ({ data, section }, { market, t, linkTo }) => {
  if (!data) {
    return {};
  }

  const { product } = data;

  if (!product) {
    return {};
  }

  const meta = getMeta(product);

  const title = t('meta', getTitleTranslationKey(section), meta);

  const description = t(
    'meta',
    getDescriptionTranslationKey(section, product),
    meta
  );

  const structuredData = productSchema(product, description);

  if (product.media?.first) {
    structuredData.image = product.media.first;
  }

  if (product.brand?.name) {
    structuredData.brand = brand(product.brand);
  }

  if (product?.userReviewSummary?.rating && product?.userReviewSummary?.count) {
    structuredData.aggregateRating = aggregateRating(product, market, t);
  }

  if (product.prices?.nodes?.length) {
    structuredData.offers = aggregateOffer(product, market);
  } else if (product.priceSummary && product.priceSummary.regular) {
    structuredData.offers = offer(product, market);
  }

  if (product.userReviews) {
    structuredData.review = reviews(product);
  }

  if (product.releaseDate) {
    structuredData.releaseDate = product.releaseDate;
  }

  if (product.coreProperties?.nodes?.length) {
    structuredData.additionalProperty = corePropertyValue(product, t);
  }

  const openGraph = graph(product, meta, description, market, t);

  const hrefLang = getHrefLang(product, markets, section);

  const canonical = getCanonical(product, section, market, linkTo);

  const faq = faqPage(product, market, t);

  return {
    title,
    description,
    thumbnail: product.media?.first,
    openGraph,
    structuredData: [structuredData, faq],
    breadcrumb: product.category?.path,
    canonical,
    android: product.pathName,
    ios: `/product/${product.id}`, // TODO: Semantic id when app can handle it
    hrefLang,
    botify: {
      page: 'product',
      category: product.category?.id,
      parentCategory:
        product.category?.path?.[product.category.path.length - 2]?.id || null,
      mainCategory: product.category?.path?.[0]?.id,
    },
  };
};
